import React from 'react';
import { useClassName, useWindowSize } from 'common/hooks';
import { AnimatedText } from '../../AnimatedText';
import './slide-into-fun.less';
import {
  getContentfulAssetUrlandAlt,
  getContentfulField,
} from 'common/components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Button } from 'common/lazy';

export const SlideIntoFun = ({ venue }) => {
  const className = useClassName('SlideIntoFun');
  const slideIntoFunFields = getContentfulField(
    venue.parkScreen?.slideIntoFun
  ).fields;
  const title = getContentfulField(slideIntoFunFields.title);
  const description = getContentfulField(slideIntoFunFields.description);
  const { isDesktop } = useWindowSize();

  const logoOverlayFields = getContentfulField(
    slideIntoFunFields.logoOverlay
  )?.fields;
  const logoOverlayFieldsFile = logoOverlayFields?.file
    ? getContentfulField(logoOverlayFields.file)
    : null;
  const logoOverlay = logoOverlayFieldsFile ? logoOverlayFieldsFile.url : null;

  const assetFields = getContentfulField(slideIntoFunFields.asset)?.fields;
  const asset = {
    desktop: getContentfulAssetUrlandAlt(assetFields.desktop),
    mobile: getContentfulAssetUrlandAlt(assetFields.mobile),
    tablet: getContentfulAssetUrlandAlt(assetFields.tablet),
  };

  const passesAndBundlesWavesFields = getContentfulField(
    venue.parkScreen?.passesAndBundleWaves
  ).fields;

  const passesAndBundlesWaves = {
    desktop: getContentfulAssetUrlandAlt(passesAndBundlesWavesFields.desktop),
  };

  const links = getContentfulField(slideIntoFunFields.links);

  const link =
    links?.length > 0
      ? {
          label: getContentfulField(links[0].fields.label),
          url: getContentfulField(links[0].fields.url),
          type: getContentfulField(links[0].fields.type),
        }
      : null;

  return (
    <div className={className('container')}>
      <img
        className={className('logo-overlay')}
        src={logoOverlay}
        alt="Logo Overlay"
      />
      <div className={className('waves')}>
        <img
          src={passesAndBundlesWaves.desktop.assetUrl}
          alt={passesAndBundlesWaves.desktop.assetAlt}
        />
      </div>
      <div className={className('header')}>
        <h2 className={className('header__title')}>
          <AnimatedText text={title} />
        </h2>
        {isDesktop && (
          <p className={className('header__description')}>
            {documentToReactComponents(description)}
          </p>
        )}
        {link && (
          <Button
            href={link.url}
            className={className('header__button')}
            content={link.label}
            target={link.type === 'external' ? '_blank' : '_self'}
          />
        )}
      </div>
      <div className={className('main-image')}>
        <img src={asset.desktop.assetUrl} alt={asset.desktop.assetAlt} />
      </div>
    </div>
  );
};
